import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'
import InlineBulletList from 'components/utils/InlineBulletList'
import Image from 'components/Common/Image'
import Group from 'components/utils/Group'

interface Props {
  amenity: App.CruiseShipAmenity
}

function CruiseShipAmenitiesModal({ amenity }: Props) {
  return <Modal title={amenity.title}>
    <Group direction="vertical" gap={16}>
      {!!amenity.imageId && <Image id={amenity.imageId} fit="center" />}

      <BodyText variant="medium" weight="normal">{amenity.description}</BodyText>

      <InlineBulletList>
        {!amenity.description && amenity.listItems?.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </InlineBulletList>
    </Group>
  </Modal>
}

export default CruiseShipAmenitiesModal
